/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 3/4/2023
 */

import { apiSlice } from "../Slices/apiSlice";

export const categoryService = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getAllTopCategories: builder.query({
            query: () => "/categories/parent-categories",
            providesTags: ['cat']
        }),

        getAllCatWithSubCat: builder.query({
            query: () => "/categories/cat-hierarchical",
            providesTags: ['cat']
        }),

        getAllCategories: builder.query({
            query: () => "/categories",
            providesTags: ['cat']
        }),

        getSubCategoriesById: builder.query({
            query: (catId) => `/categories/sub-categories/${catId}`
        }),

        getCategoryById: builder.query({
            query: (catId) => `/categories/${catId}`,
            providesTags: ['cat']
        }),

        createCategory: builder.mutation({
            query: (catDetails) => ({
                url: '/categories',
                method: 'POST',
                body: catDetails
            }),
            invalidatesTags: ['cat']
        }),

        updateCategory: builder.mutation({
            query: (catDetails) => ({
                url: `categories/${catDetails.catId}`,
                method: 'PUT',
                body: catDetails
            }),
            invalidatesTags: ['cat']
        }),

        deleteCategory: builder.mutation({
            query: (catId) => ({
                url: `/categories/${catId}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['cat']
        }),

        getAllAttTypes: builder.query({
            query: () => "/cat-attr-types",
            providesTags: ['cat']
        }),

        

    })
});

export const {
    useGetAllTopCategoriesQuery,
    useGetAllCategoriesQuery,
    useGetAllCatWithSubCatQuery,
    useGetSubCategoriesByIdQuery,
    useGetCategoryByIdQuery,
    useCreateCategoryMutation,
    useUpdateCategoryMutation,
    useDeleteCategoryMutation,
    useGetAllAttTypesQuery
} = categoryService;